export default [
  {
    header: 'Gestión Forecast',
    resource: 'Tipo Re'
  },
  {
    title: 'Mantenedor F',
    icon: 'ServerIcon',
    children: [
      {
        title: 'Cultivo',
        route: 'cultivoforere',
        action: 'menu',
        resource: 'Cultivo Fore Re'
      },
      {
        title: 'Forecast Year',
        route: 'forecastyearre',
        action: 'menu',
        resource: 'Forecast year Re'
      },
      {
        title: 'Tipo',
        route: 'tipore',
        action: 'menu',
        resource: 'Tipo Re'
      },
      {
        title: 'Versión',
        route: 'versionre',
        action: 'menu',
        resource: 'Version Re'
      },
      {
        title: 'Fecha',
        route: 'fechare',
        action: 'menu',
        resource: 'Fecha Re'
      },
    ],
  },
  {
    title: 'Forecasting',
    route: 'forecastingre',
    icon: 'BarChart2Icon',
    action: 'menu',
    resource: 'Forecasting Re'
  },

]
